import { mount } from 'svelte'
import Review from '@/components/draft-review/Review.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('draft-review-app')
  if (el) {
    mount(Review, {
      target: el,
      props: {
        fireHashid:  el.dataset.fireHashid,
        apiUrl:      el.dataset.apiUrl,
        sendUrl:     el.dataset.sendUrl,
        discardUrl:  el.dataset.discardUrl,
        csrfToken:   el.dataset.csrfToken,
      },
    })
  }
})
